//@ts-nocheck
import clsx from "clsx";
import "./ARCPosition.css";
import Atom from "../atom/index";
import Storage from "../../lib/storage/storage";
import ARCElement from "../ARCElement/ARCElement";
import React, { useEffect, useState } from "react";
import { isInTime, jsonParse } from "../../lib/utils";
import {
  findBootstrapSize,
  getWidthSize,
} from "../../hooks/sizeListener/useSizeListener";
import { useLocationSplitter } from "../../hooks/router/useLocation";

export default function ARCPosition(props) {
  const { data, template: tmp, update, isDown, isUp } = props;

  const [, setPosition] = useState([]);
  const [view, setView] = useState([]);
  const [sortList, setSort] = useState({});
  const [containerName, setContainerName] = useState([]);

  const locationSplitter = useLocationSplitter();

  useEffect(() => {
    if (data) {
      const position = [];
      const containerList = [];
      const sort = {};

      for (const i in data) {
        const { position: p } = data[i];
        const [containerName] = p.split("-");
        if (containerName && !containerList.includes(containerName)) {
          containerList.push(containerName);
          if (!sort[containerName]) {
            sort[containerName] = [];
          }
        }
        sort[containerName].push(data[i]);
        position.push(p);
      }
      setPosition(position);

      setContainerName((prevState) => [
        ...new Set([...prevState, ...containerList]),
      ]);
      setSort((prevSort) => ({ ...prevSort, ...sort }));
    }
     
  }, [data, update]);

  useEffect(() => {
    if (containerName.length) {
      const template = searchDeletedItems(tmp);
      const merged = recursiveMerge(template);
      const view = getView({ template: merged });

      setView(view);
    }

  }, [containerName, sortList]);

  const searchDeletedItems = (template) => {
    for (const i in template?.properties) {
      const share = template?.properties[i]?.contribution?.share;
      const { status } = checkMedia(sortList[i]);
      if (!status) {
        delete template?.properties[i];
        // template.properties = { ...template.properties, MustDelete: true };
      } else {
        const isIncludesKey = Object.keys(sortList).some((k) => k.includes(i));
        if (
          !isIncludesKey &&
          template?.properties[i]?.type === "container" &&
          share !== "fix"
        ) {
          delete template?.properties[i];
          // template.properties = { ...template.properties, MustDelete: true };
        } else if (
          !isIncludesKey &&
          template?.properties[i]?.type === "object" &&
          share !== "fix"
        ) {
          for (const j in template?.properties[i]?.properties) {
            if (template?.properties[i]?.properties[j]?.type === "container") {
              const { status } = checkMedia(sortList[j]);
              if (!status || !sortList[j]) {
                // template.properties[i].properties = { ...template.properties[i].properties, MustDelete: true };
                delete template.properties[i].properties[j];
              }
            } else if (
              template?.properties[i]?.properties[j]?.type === "object"
            ) {
              template.properties[i].properties[j] = searchDeletedItems(
                template?.properties[i]?.properties[j]
              );
            }
          }
        }
      }
    }
    return template;
  };

  const checkMedia = (item) => {
    const width = getWidthSize();
    const bootstrapSize = findBootstrapSize(width);

    if (Array.isArray(item)) {
      let showMedia = false;
      let newProps = "";
      for (const k in item) {
        let media = item[k]?.media;
        media = jsonParse(media);
        if (!media || (media && media[bootstrapSize] !== "none")) {
          showMedia = true;
          if (media && typeof media[bootstrapSize] === "object") {
            newProps = media[bootstrapSize];
          }
          break;
        }
      }
      return { status: showMedia, newProps };
    }

    let media = item?.media;
    media = jsonParse(media);

    let showMedia = true;
    let newProps = "";
    if (media && media[bootstrapSize] === "none") {
      showMedia = false;
    } else if (media && typeof media[bootstrapSize] === "object") {
      newProps = media[bootstrapSize];
    }
    return { status: showMedia, newProps };
  };

  const recursiveMerge = (template) => {
    const newTemp = mergeTemplate(template);
    for (const i in newTemp.properties) {
      if (newTemp?.properties[i] && !newTemp?.properties[i]?.MustDelete) {
        for (const j in newTemp?.properties[i].properties) {
          if (!newTemp?.properties[i]?.properties[j].MustDelete) {
            if (newTemp?.properties[i]?.properties[j].type === "container") {
            } else if (
              newTemp?.properties[i]?.properties[j].type === "object"
            ) {
              newTemp.properties[i].properties[j] = recursiveMerge(
                newTemp.properties[i].properties[j]
              );
            }
          }
        }
      }
    }

    return newTemp;
  };

  const mergeTemplate = (template) => {
    //share: filler, fit, fix
    const shares = {};
    const deletedItem = {};
    for (const i in template?.properties) {
      const share = template?.properties[i]?.contribution?.share;
      if (!shares[share]) {
        shares[share] = [];
      }
      if (
        template?.properties[i]?.properties &&
        !Object.keys(template?.properties[i]?.properties)?.length
      ) {
        deletedItem[i] = template?.properties[i];
      }
      shares[share].push({ ...template?.properties[i], ContainerName: i });
    }

    if (Object.keys(deletedItem).length) {
      let sumDelete = 0;
      for (const i in deletedItem) {
        const allotment = deletedItem[i]?.contribution?.allotment;
        sumDelete += allotment;
        delete template.properties[i];
      }
      if (shares["filler"]) {
        let sumAllotment = 0;
        for (const i in shares["filler"]) {
          if (!deletedItem[shares["filler"][i].ContainerName]) {
            sumAllotment += shares["filler"][i]?.contribution?.allotment;
          }
        }
        for (const i in shares["filler"]) {
          if (
            !deletedItem[shares["filler"][i].ContainerName] &&
            template.properties[shares["filler"][i].ContainerName]?.contribution
              .allotment
          ) {
            const allotment = shares["filler"][i]?.contribution?.allotment;
            const val = Math.floor((allotment / sumAllotment) * sumDelete);

            template.properties[
              shares["filler"][i].ContainerName
            ].contribution.allotment =
              shares["filler"][i]?.contribution?.allotment + val;
          }
        }
      }
    }

    return template;
  };

  const getView = ({ template, container }) => {
    const view = [];
    const FooterView = [];

    const cols = getColParts(template);

    for (const i in template?.properties) {
      const col = cols[i];

      const thisParent = [];
      if (container) {
        thisParent.push(container);
      }
      thisParent.push(i);

      const { content, footer } = getItemView(template?.properties[i], i);
      FooterView.push(footer);

      view.push(
        <Atom.Div key={`${i} ${container || ""}`} className={col}>
          {content}
        </Atom.Div>
      );
    }

    return (
      <React.Fragment key={container}>
        {view}
        {FooterView}
      </React.Fragment>
    );
  };

  const getColParts = (template) => {
    //share: filler, fit, fix

    const parts = [];
    for (const i in template?.properties) {
      if (template.properties[i]?.contribution?.allotment === "row") {
      } else {
        parts.push(template.properties[i]?.contribution?.allotment);
      }
    }
    const sum = parts.reduce((partialSum, a) => partialSum + a, 0);

    const cols = {};

    for (const i in template?.properties) {
      const thisPart = template.properties[i]?.contribution?.allotment;
      if (thisPart !== "row") {
        const col = Math.floor((thisPart * 12) / sum);
        cols[i] = `col-${col || 12}`;
      } else {
        cols[i] = "row";
      }
    }

    return cols;
  };

  const getItemView = (object, container) => {
    let content = [];
    let footer = [];

    const templateContainer = object?.properties
      ? Object.keys(object?.properties)[0]
      : "";

    const containerClass =
      _TemplateConfig?.container &&
      _TemplateConfig?.container[templateContainer]?.class;

    const pageClass =
      _TemplateConfig[locationSplitter]?.container?.[templateContainer]?.class;

    let tag = "div";
    if (isDown) {
      tag = "footer";
    } else if (isUp) {
      tag = "header";
    }
    if (object?.type === "container") {
      const element = React.createElement(
        tag,
        {
          key: `${container}-position`,
          className: clsx(
            "row px-0 mx-0 positionRow", //این با اضافه کردن خاصیت تکراری بودن order قبلی یا row جدید اضافه شده برای شهر سونی
            `${container}-position`,
            object?.className,
            containerClass,
            pageClass
          ),
        },
        <PositionView list={sortList[container]} />
      );
      if (tag !== "footer") {
        content.push(element);
      } else {
        footer.push(element);
      }
    } else if (object?.type === "object") {
      if (object?.properties) {
        content = [];
        footer = [];
        for (const j in object?.properties) {
          if (object?.properties[j]?.type === "container") {
            const cols = getColParts(object);

            if (cols[j] === "col-12") cols[j] = "ARCContainer";
            const element = React.createElement(
              tag,
              {
                key: `${j}-position`,
                className: clsx(
                  cols[j],
                  `${j}-position`,
                  object?.class,
                  containerClass,
                  pageClass,
                  ""
                ),
              },
              <PositionView list={sortList[j]} />
            );
            if (tag !== "footer") {
              content.push(element);
            } else {
              footer.push(element);
            }
          } else if (object?.properties[j]?.type === "object") {
            const element = getView({
              template: object?.properties[j],
              container: j,
            });
            if (tag !== "footer") {
              content = [...content, ...[element]];
            } else {
              footer = [...footer, ...[element]];
            }
          }
        }
      }
    }

    return { content, footer };
  };

  const PositionView = ({ list }) => {
    const user = Storage.getUser();
    if (list?.length) {
      const view = [];
      const rowToItems = {};

      for (const i in list) {
        const { width, height, row, status } = getElementSize(list[i].position);

        // const { status: mediaStatus } = checkMedia(list[i]);

        if (!rowToItems[row]) {
          rowToItems[row] = [];
        }
        rowToItems[row].push({
          ...list[i],
          WIDTH: width,
          STATUS: status,
          HEIGHT: height,
        });
      }

      for (const i in rowToItems) {
        //مرتب سازی بر اساس ordering element
        const sortArray = rowToItems[i].sort((a, b) => b.ordering - a.ordering);
        for (const j in sortArray) {
          const listObj = sortArray[j];
          if (listObj) {
            const pages = jsonParse(listObj.pages);
            let componentProps =
              props[`${listObj.element}-${listObj.ID}`] || {};
            if (pages) {
              const pathname = window.location.pathname;
              const elsing = pages["@"] ? Object.keys(pages["@"]) : [];
              const equaling = pages["="] ? Object.keys(pages["="]) : [];

              if (elsing.length) {
                for (const k in elsing) {
                  const regex = new RegExp(elsing[k]);
                  if (regex.test(pathname)) {
                    componentProps = {
                      ...componentProps,
                      ...pages["@"][elsing[k]],
                    };
                  }
                }
              }
              if (equaling.length) {
                for (const k in equaling) {
                  const regex = new RegExp(equaling[k]);
                  if (regex.test(pathname)) {
                    componentProps = {
                      ...componentProps,
                      ...pages["="][equaling[k]],
                    };
                  }
                }
              }
            }

            const { status, newProps } = checkMedia(listObj);

            const replaceProps = newProps?.properties || {};
            const mergeProps = {
              ...listObj,
              ...replaceProps,
              ...componentProps,
            };

            if (
              (mergeProps?.trashed && mergeProps.trashed == 1) ||
              !isInTime(mergeProps?.published)
            ) {
            } else {
              if (status) {
                const col = listObj.WIDTH;

                let currentStatus;
                if (!listObj.STATUS || listObj.STATUS === "N") {
                  currentStatus = true;
                } else if (user.loggedIn && listObj.STATUS === "L") {
                  currentStatus = true;
                } else {
                  currentStatus = !user.loggedIn && listObj.STATUS === "O";
                }
                if (currentStatus) {
                  view.push(
                    <Atom.Div
                      key={listObj?.ID}
                      id={`ARCPosition-${listObj?.ID}`}
                      className={`col-${col}`}
                    >
                      <ARCElement {...mergeProps} />
                    </Atom.Div>
                  );
                }
              }
            }
          }
        }
      }

      return view;
    }
  };

  const getElementSize = (elementPosition) => {
    const numsWithBrack = elementPosition?.split("{");
    const nums =
      numsWithBrack && numsWithBrack.length && numsWithBrack[1]
        ? numsWithBrack[1].split("}")
        : "";
    if (nums[0]) {
      const [box, row, width, height, status] = nums[0].split(",");
      return { width, height, row, status, box };
    }
    return { width: "", height: "" };
  };

  return <React.Fragment>{view}</React.Fragment>;
}
